import compareService from 'common/util/compareService';

export default function () {
	$(document).on('click', '.js-compare-button', function () {
		let $button = $(this);
		let product = {
			id: +$button.data('product-id'),
			name: $button.data('product-name'),
			image: $button.data('product-image')
		};

		if ($button.hasClass('js-active')) {
			compareService.remove(product);
		} else {
			compareService.add(product);
		}
	});

	compareService.addListenerAdd(product => {
		$('.js-compare-button').each(function () {
			let $button = $(this);
			let productId = +$button.data('product-id');

			if (product.id !== productId) {
				return;
			}

			const $tooltip = $(`.tooltip-compare-product-${productId}`);
			$button.addClass('js-active');
			$tooltip.css({'visibility': 'hidden'}).find('.tooltip-inner').html($button.attr('data-title-success'));
		});
	});

	compareService.addListenerRemove(product => {
		$('.js-compare-button').each(function () {
			let $button = $(this);
			let productId = +$button.data('product-id');

			if (product.id !== productId) {
				return;
			}

			const $tooltip = $(`.tooltip-compare-product-${productId}`);
			$button.removeClass('js-active');
			$tooltip.css({'visibility': 'hidden'}).find('.tooltip-inner').html($button.attr('data-title'));
		});
	});
}
